import { render } from "./ManufacturersV2.vue?vue&type=template&id=181c908a&scoped=true"
import script from "./ManufacturersV2.vue?vue&type=script&lang=ts"
export * from "./ManufacturersV2.vue?vue&type=script&lang=ts"

import "./ManufacturersV2.vue?vue&type=style&index=0&id=181c908a&scoped=true&lang=css"
import "./ManufacturersV2.vue?vue&type=style&index=1&id=181c908a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-181c908a"

export default script